<template>
  <div>
    <div>
      <h2>Episodes</h2>
      <div class="select-season">
        <select :label="season_selected" v-model="season_selected">
          <template v-for="(item, index) in seasons">
            <option :value="index" :key="index"> {{ item }} </option>
          </template>
        </select>
      </div>

      <ith-detail-episodes-detail
        v-if="showDetail.seasons"
        :items="showDetail.seasons[season_selected]"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["showDetail", "seasons"]),
  data: () => ({
    season_selected: 0
  })
};
</script>

<style scoped>
h2 {
  font-weight: 400;
  border-bottom: 1px solid #738092;
}

select {
  width: 180px;
  border-radius: 10px;
  background-color: #738092;
  color: #284367;
  border: 1px solid #707070;
  margin: 15px 0;
  padding: 10px;
  font-size: 1em;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
